function installManagementCalendar({ Framework, CalendarLibrary }) {
  Framework.use(CalendarLibrary, {
    componentPrefix: 'vc',
  });
}

module.exports = installManagementCalendar;
